import { render } from "./ui-text.vue?vue&type=template&id=7b76fcdb&scoped=true"
import script from "./ui-text.vue?vue&type=script&lang=js"
export * from "./ui-text.vue?vue&type=script&lang=js"

import "./ui-text.vue?vue&type=style&index=0&id=7b76fcdb&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b76fcdb"],['__file',"src/components/ui/ui-text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b76fcdb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b76fcdb', __exports__)) {
    api.reload('7b76fcdb', __exports__)
  }
  
  module.hot.accept("./ui-text.vue?vue&type=template&id=7b76fcdb&scoped=true", () => {
    api.rerender('7b76fcdb', render)
  })

}


export default __exports__